module.exports = __webpack_public_path__ + "images/share-d7139da6.svg";